import { pluginTemplateParser } from './tactictriggeredtemplates/pluginTemplateParser';

/**
 * the trigger details for a tactic that was either filtered, entered, or exited on
{
	"messageType": "alertNotification",
	"notificationId": 1645473057989,
	"notificationDetails": {"updateType":"ENTRY_TRIGGERED","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "TACTIC_TRIGGERED",
	"statusDetails": {"pluginTemplate":{"candleDuration":1,"timeUnit":"MINUTES","candle":{"high":100.2,"low":100.2,"open":100.2,"close":100.2,"candleSymbol":"XTz","candleStartTimeStamp":1641110640000,"duration":"1min"}},"triggerPrice":100.2,"tradeDirection":"LONG","tacticName":"CANDLE_BREAK","symbol":"xyz"},
	"date": "2022-02-21T14:50:58.633-0500",
	"timestamp": "1645473058635"
}

 * @param {*} statusDetails 
 * @returns object with fields:
 * 1) triggerPrice 
 * 2) tradeDirection (LONG/SHORT/null if exit tactic or filtered)
 * 3) tacticName
 * 4) symbol
 * 5) pluginTemplate-> this is an object with the relevant information about the tactic.

 */
export function tacticTriggerParser(statusDetails) {
  const parsedObj = {
    triggerPrice: null,
    tradeDirection: null,
    tacticName: null,
    symbol: null,
    pluginTemplate: null, //todo
  };
  if (statusDetails) {
    parsedObj.triggerPrice = statusDetails.triggerPrice ?? null;
    parsedObj.tradeDirection = statusDetails.tradeDirection ?? null;
    parsedObj.tacticName = statusDetails.tacticName ?? null;
    parsedObj.symbol = statusDetails.symbol ?? null;
    const pluginTemplate = pluginTemplateParser(statusDetails.pluginTemplate, parsedObj.tacticName) ?? null;
    if (pluginTemplate) {
      parsedObj.pluginTemplate = pluginTemplate;
    }
  }
  return parsedObj;
}
